<template>
  <div class="wrapper" :class="['wrapper-' + $store.getters.platform, { 'no-margin': noMargin }]">
    <app-loader v-if="!categories.length && !noData"></app-loader>
    <div v-else>
      <!-- <keep-alive> -->
        <router-view :key="$route.fullPath" />
      <!-- </keep-alive> -->

      <!-- main video -->
      <VideoMain v-if="$route.name === 'content' && display && ($store.getters.getData.video || $store.getters.getData.content)" ref="video"></VideoMain>

      <!-- Slider -->
      <main-carousel v-if="$store.getters.client.slider.length" :slides="$store.getters.client.slider[0].slide" />
      <!-- categories -->
      <div style="padding: 2.6rem 0rem 2.6rem 0rem">
        <!-- previous -->
        <div style="text-align: center">
          <a v-if="previous" @click="paginate('previous')" @keyup.enter="paginate('previous')" class="waves-effect waves-light btn-large focusable-previous" tabindex="-1">{{$t('GENERAL.PAGINATE-PREVIOUS')}}</a>
        </div>

         <div v-for="cat in categories" :key="cat.id" style="overflow: hidden;">
          <app-list v-if="!cat.is_final"
            :options="{
              id: cat.id,
              type: 'card-categories',
              title: cat.name,
              items: cat.child_categories,
              route: 'content-category',
              card: cat.card,
              typeCat: cat.type,
              wrapper: $el
            }"
            @setLastFocused="setLastFocused($event)"
            @trailerPlay="pauseVideo"
            @trailerStop="playVideo"
          />
          <app-list v-if="cat.is_final" v-show="(cat.type !== 'FAV' && cat.type !== 'LAS') || $store.getters.user"
            :options="{
              id: cat.id,
              type: 'card-contents',
              title: cat.name,
              items: cat.category_content,
              route: 'content-detail',
              card: cat.card,
              typeCat: cat.type,
              wrapper: $el
            }"
            @setLastFocused="setLastFocused($event)"
            @trailerPlay="pauseVideo"
            @trailerStop="playVideo"
          />
        </div>

        <!-- next -->
        <div style="text-align: center">
          <a v-if="next" @click="paginate('next')" @keyup.enter="paginate('next')" class="waves-effect waves-light btn-large focusable-next" tabindex="-1">{{$t('GENERAL.PAGINATE-NEXT')}}</a>
        </div>
      </div>

      <!-- control bar -->
      <ControlBar v-if="$store.getters.getData.control_bar && $store.getters.platform !== 'browser'" :keys="keys" />

      <div id="back-browser-root" ref="back" class="back-browser fadein-browser"
      @click="back" v-if="$store.getters.platform === 'browser' && !share && !iframe" v-show="$route.name !== 'content'">
        <icon name="arrow-left"></icon>
      </div>

      <Modal v-if="showModal">
        <img slot="header" :src="$store.getters.getData.logo_mono" :alt="$store.getters.getData.name">

        <div v-if="showModal === 'countries'" slot="body">
          <p>{{ $t("GENERAL.SELECT-COUNTRY") }}</p>
          <div id="countries" class="wrapper-features">
            <a v-for="c in countries" :key="c.id" class="waves-effect waves-light btn" @click="setLocale(c.language.locale)">
              {{c.country}}
            </a>
          </div>
        </div>

        <div v-if="showModal === 'consent'" slot="body">
          <p> {{ $t("GENERAL.SELECT-COUNTRY") }}</p>
          <div id="countries" class="wrapper-features">
            <a v-for="c in countries" :key="c.id" class="waves-effect waves-light btn" :c-locale="c.language.locale" @click="selectCountry($event)">
              {{c.country}}
            </a>
          </div>
          <p>{{ $t("GENERAL.CONSENT") }}</p>
        </div>
        <div v-if="showModal === 'consent'" slot="footer">
          <a @click="closeModal('exit')" class="waves-effect waves-light btn modal-focusable">{{ $t("KEYS.EXIT") }}</a>
          <a @click="closeModal('accept')" class="waves-effect waves-light btn modal-focusable">{{ $t("GENERAL.ACCEPT") }}</a>
        </div>
      </Modal>

    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
// Lo cargamos aqui por el fallo de que se ralentizaba al cargar el css y se veian todas las imagenes en prod
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import VideoMain from '@/components/video-main'
import ControlBar from '@/components/ControlBar'
import mainCarousel from '@/components/main-carousel'
import {StatsRootContentCategories} from '@/utils/constants'
import { setLocation, getLocation } from '@/utils/helper-functions'
import Modal from '@/components/ModalCountries'
const contentsService = require('@/services/contents.js')

export default {
  name: 'RootContentCategories',
  components: { 'app-list': List, 'app-loader': Loader, VideoMain, ControlBar, mainCarousel, Modal },
  data () {
    return {
      categories: {},
      noData: false,
      lastFocused: null,
      videoPlayer: null,
      display: true,
      keys: [
        {text: this.$i18n.t('KEYS.EXIT'), action: this.$i18n.t('KEYS.CLOSE')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'red', action: this.$i18n.t('KEYS.TOP')}
      ],
      previous: false,
      next: false,
      setInterval: false,
      time: 0,
      noMargin: false,
      showModal: false
    }
  },
  watch: {
    // al volver de otra ruta hacemos focus sobre la última lista seleccionada
    $route: function () {
      if (this.$route.name === 'content') {
        setTimeout(() => {
          SpatialNavigation.focus(this.lastFocused)
          SpatialNavigation.resume()
          this.playVideo()
        }, 0)
      } else { this.pauseVideo() }

      document.querySelector('body').style.overflowY = 'auto'
    }
  },
  created: function () {
    // metas
    // document.title = this.$i18n.t('MENU.CONTENTS')
    // document.querySelector('meta[name="Description"]').setAttribute('content', this.$store.getters.getData.display_name)

    this.countries = this.$store.getters.getData.countries
    if (!this.$store.getters.user && this.countries.length) {
      this.locale = localStorage.getItem('locale-demo')
      if (!this.locale) {
        if (this.countries.length === 1) {
          this.locale = this.countries[0].language.locale
          localStorage.setItem('locale-demo', this.locale)
          this.getGeolocation()
        } else {
          this.showModal = this.$store.getters.getData.name === 'pinkotv' ? 'consent' : 'countries'
          this.noData = true
        }
      } else {
        this.getGeolocation()
      }
    } else {
      this.locale = false
      this.getGeolocation()
    }
  },
  beforeMount: function () {
    // TODO -> una vez que tengamos slider desde back mostrar si existe vídeo o slider
    if (this.$store.getters.getData.template1 === 'SUR') {
      this.noMargin = true
    }

    if (this.$route.name === 'content') { window.Countly.q.push(['track_pageview', StatsRootContentCategories]) }
    window.scrollTo(0, 0)
  },
  mounted: function () {
    this.onResize()
    window.addEventListener('resize', this.onResize)

    // keys control
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-red', this.keyRed)

    // back browser
    if (this.$store.getters.platform === 'browser' && !this.share && !this.iframe) {
      this.setInterval = setInterval(() => {
        this.time = this.time + 1
        if (this.time >= 3 && this.$refs.back) {
          this.$refs.back.classList.remove('fadein-browser')
          this.$refs.back.classList.add('fadeout-browser')
        }
      }, 1000)

      this.$el.addEventListener('mousemove', () => {
        if (this.$refs.back) {
          this.$refs.back.classList.remove('fadeout-browser')
          this.$refs.back.classList.add('fadein-browser')
        }
        this.time = 0
      })
    }
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getCategories(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getCategories(position.coords.latitude, position.coords.longitude)
            },
            () => { this.getCategories(0, 0) },
            options)
        } else {
          this.getCategories(0, 0)
        }
      }
    },
    getCategories (lat, lon) {
      // CATEGORÍAS
      contentsService.listCategories(lat, lon, this.locale).then(response => {
        this.categories = response.data['results']
        document.querySelector('body').style.overflowY = 'auto'

        // sin categprías
        if (!this.categories.length) {
          this.noData = true
          SpatialNavigation.resume()
          SpatialNavigation.focus()
        }

        this.next = response.data.next
        if (this.next) {
          SpatialNavigation.add({selector: '.focusable-next', restrict: 'self-first'})
          SpatialNavigation.makeFocusable()
        }
      })
    },
    back: function () { this.$router.go(-1) },
    keyBack () {
      if (this.$route.name === 'content') {
        if (this.previous) {
          this.paginate('previous')
        } else if (window.webOS) {
          window.webOS.platformBack() // mostramos bar laucher LG
        } else if (typeof (toast) !== 'undefined') {
          // eslint-disable-next-line
          toast.application.exit()
        }
      }
    },
    keyRed () {
      if (this.$route.name === 'content' && this.$store.getters.getData.control_bar && this.$store.getters.platform !== 'browser') { SpatialNavigation.focus() }
    },
    setLastFocused (e) { this.lastFocused = e.id },
    playVideo () { if (this.$refs.video) this.$refs.video.playVideo() },
    pauseVideo () { if (this.$refs.video) this.$refs.video.pauseVideo() },
    onResize () { (window.innerWidth >= 1200) ? this.display = true : this.display = false },
    paginate: function (action) {
      if (this[action]) {
        this.categories = []

        setTimeout(() => {
          document.querySelector('#app-content').scrollTo(0, 0)
          document.getElementById('app').scrollIntoView()
        }, 0)

        contentsService.paginate(this[action]).then(response => {
          this.categories = response.data['results']
          this.previous = response.data.previous
          this.next = response.data.next

          if (this.previous) {
            SpatialNavigation.add({selector: '.focusable-previous', restrict: 'self-first'})
            SpatialNavigation.makeFocusable()
          }

          if (this.next) {
            SpatialNavigation.add({selector: '.focusable-next', restrict: 'self-first'})
            SpatialNavigation.makeFocusable()
          }
        })
      }
    },
    closeModal: function (action) {
      const locale = this.$el.querySelector('#countries .active')
      if (action === 'exit') {
        window.location.replace('http://www.google.com')
      } else if (!locale) {
        M.Toast.dismissAll()
        M.toast({html: this.$i18n.t('GENERAL.SELECT-COUNTRY'), classes: 'red lighten-1'})
      } else {
        this.setLocale(locale.getAttribute('c-locale'))
      }
    },
    selectCountry: function (e) {
      const old = this.$el.querySelector('#countries .active')
      if (old) old.classList.remove('active')
      e.target.classList.toggle('active')
    },
    setLocale: function (locale) {
      this.locale = locale
      localStorage.setItem('locale-demo', this.locale)
      this.noData = false
      this.getGeolocation()
      this.showModal = false
    }
  },
  computed: {
    share: function () {
      return (typeof this.$route.query.share) !== 'undefined'
    },
    iframe: function () {
      return (typeof this.$route.query.iframe) !== 'undefined' && this.$store.getters.platform === 'browser'
    }
  },
  beforeDestroy: function () {
    clearInterval(this.setInterval)
    window.removeEventListener('resize', this.onResize)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-red', this.keyRed)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  width: 100%
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox

  &.no-margin
    margin-top: 0px!important

#slider
  position: relative
  width: 100vw
  height: calc(100vw * .40)
  background-image: url("https://itvty-canalsur.s3-eu-west-1.amazonaws.com/category_backgrounds/Tierra-de-talento-Slider.jpg")
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

.wrapper-features
  display: flex
  flex-direction: column
  align-items: center
  margin-bottom: 1.5rem

  .btn
    width: 16rem
    margin-bottom: .8rem

    span:first-child
      font-weight: bold

  .btn.active
    color: #f8f9fa!important;
    background-color: rgba(0,0,0,.5)!important;

.wrapper-features-focusable
  outline: none

@media only screen and (max-width: 1200px)
  #video-main
    display: none

@media only screen and (min-width: 1200px)
  #video-main.video-main-browser + div
    margin-top: -17rem

@media only screen and (min-width: 1200px)
  #video-main.video-main-tv + div
    margin-top: -28rem

@media only screen and (min-width: 2560px)
  #video-main.video-main-tv + div
    margin-top: -27rem

@media only screen and (min-width: 4096px)
  #video-main.video-main-tv + div
    margin-top: -29rem
</style>



// WEBPACK FOOTER //
// src/pages/contents/RootContentCategories.vue